module.exports = __webpack_public_path__ + "018337d0d5c783bc9ebae9da81d467cc.png";